import styled from 'styled-components';

import { media } from '@/utils/mediaQueries';

export const EditBox = styled.a`
    position: absolute;
    top: 15px;
    right: -60px;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s ease-in-out;
    z-index: 1;
    width:30px;
    height: 30px;
    background: ${({ theme }) => theme.colors.card.background};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(37, 83, 185, 0.1) 0 2px 6px')};

    /* Dotyk (brak hover): akcje zawsze widoczne. */
    ${media.touch} {
        right: 15px;
        opacity: 1;
        pointer-events: auto;
    }
`;

export const QrCodeCardWrapper = styled.div`
    width: 100%;
    height: auto;
    background: ${({ theme }) => theme.colors.card.background};
    border-radius: 6px;
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(37, 83, 185, 0.1) 0 2px 6px')};
    padding:  15px 20px;
    position:relative;
    overflow: hidden;
    cursor: pointer;
    &:hover ${EditBox} {
        right: 15px;
        top: 15px;
        bottom: auto;
        opacity: 1;
        pointer-events: auto;
        transform: translate(0%, 0%);
    }
`;

export const CodeWrapper = styled.div`
    width:100%;
    height: auto;
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(37, 83, 185, 0.1) 0 2px 6px')};
`;

export const Phone = styled.h3`
    font-size: 16px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text.secondary};
    line-height: 1.7;
    padding: 5px 0;
`;

export const Title = styled.div`
    width: 100%;
    height: 40px;
    padding: 5px 15px;
    border-radius: 6px;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e5e5')};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: ${({ theme }) => theme.colors.text.secondary};
    gap: 5px;
    font-size: 14px;
    margin:10px 0;
`;

export const Description = styled.p`
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.text.secondary};
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;
